/**
 * Mirror of bella/server/utils/services.js — keep in sync.
 *
 * The client uses this for:
 *  - showing the service dropdown
 *  - displaying duration hints in the booking form
 *  - rendering time labels
 *
 * Duration & slot rules are enforced by the server. Client just
 * reflects what the server allows.
 */

export const SERVICE_CATALOG = [
  { name: 'Haircut',            durationMinutes: 60  },
  { name: 'Hair coloring',      durationMinutes: 180 },
  { name: 'Haircut + Coloring', durationMinutes: 240 },
];

export const SERVICES = SERVICE_CATALOG.map((s) => s.name);

export const DURATION_BY_SERVICE = SERVICE_CATALOG.reduce((acc, s) => {
  acc[s.name] = s.durationMinutes;
  return acc;
}, {});

export function getServiceDuration(name) {
  if (!name) return null;
  return DURATION_BY_SERVICE[name] || null;
}

/**
 * Renders e.g. 60 → "1 hr"; 180 → "3 hr"; 90 → "1.5 hr"; 240 → "4 hr"
 */
export function formatDuration(mins) {
  if (!Number.isFinite(mins) || mins <= 0) return '';
  const h = mins / 60;
  if (Number.isInteger(h)) return `${h} hr`;
  return `${h.toFixed(1)} hr`;
}

export function formatTimeLabel(hhmm) {
  if (typeof hhmm !== 'string' || !/^\d{2}:\d{2}$/.test(hhmm)) return hhmm;
  const [h, m] = hhmm.split(':').map((v) => parseInt(v, 10));
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, '0')} ${ampm}`;
}